import React from 'react';
import { Building2, Building, Users, GraduationCap, HeartPulse, Dumbbell, Home } from 'lucide-react';
import { mockData } from '../mock';

const iconMap = {
  'building': Building,
  'building-2': Building2,
  'users': Users,
  'graduation-cap': GraduationCap,
  'heart-pulse': HeartPulse,
  'dumbbell': Dumbbell,
  'home': Home,
};

export const UseCases = () => {
  const { useCases } = mockData;

  return (
    <section id="use-cases" className="py-20 lg:py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 md:mb-4 tracking-tight">
            {useCases.title}
          </h2>
          <p className="text-base md:text-lg text-gray-600">{useCases.subtitle}</p>
        </div>

        {/* Use Cases Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {useCases.cases.map((useCase) => {
            const Icon = iconMap[useCase.icon];
            return (
              <div
                key={useCase.id}
                className="group rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
              >
                {/* Image */}
                <div className="relative h-48 overflow-hidden bg-gradient-to-br from-[#2AD7C5]/20 to-gray-100">
                  <img
                    src={useCase.imagePlaceholder}
                    alt={useCase.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  {/* Icon Overlay */}
                  <div className="absolute top-4 left-4">
                    <div className="w-12 h-12 bg-white/90 backdrop-blur-sm rounded-xl flex items-center justify-center shadow-lg">
                      <Icon className="text-[#2AD7C5]" size={24} />
                    </div>
                  </div>
                </div>

                {/* Content */}
                <div className="p-6 bg-white">
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">
                    {useCase.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {useCase.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
